// src/utils/authExtras.js
// Login aur Register dono ke liye common helper — deviceId, deviceName,
// address (permission based), fcmToken (agar Firebase set up ho) collect karta hai
import { getOrCreateDeviceId, getDeviceName, DEVICE_TYPE } from './device';
import { getAddressIfPermitted } from './location';
import { getFcmTokenIfAvailable } from './fcm';

export const collectAuthExtras = async () => {
  const deviceId   = getOrCreateDeviceId();
  const deviceName = getDeviceName();
  const deviceType = DEVICE_TYPE;

  const [address, fcmToken] = await Promise.all([
    getAddressIfPermitted(),
    getFcmTokenIfAvailable(),
  ]);

  return {
    deviceId,
    deviceName,
    deviceType,
    address: address || undefined,
    fcmToken: fcmToken || undefined,
  };
};